(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SymptomDialogController', SymptomDialogController);

    SymptomDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Symptom', 'Infection', 'Corporation'];

    function SymptomDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Symptom, Infection, Corporation) {
        var vm = this;

        vm.symptom = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.infections = Infection.query();
        // vm.corporations = Corporation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.symptom.id !== null) {
                Symptom.update(vm.symptom, onSaveSuccess, onSaveError);
            } else {
                Symptom.save(vm.symptom, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:symptomUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
